import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogTemplateButtonComboStyleEnum } from '@shared/components/templates/dialog-template/enums/dialog-template-button.enum';
import { DialogTemplateIconColorEnum } from '@shared/components/templates/dialog-template/enums/dialog-template-icon-color.enum';
import { DialogTemplateTitleColorEnum } from '@shared/components/templates/dialog-template/enums/dialog-template-title.enum';

export interface DeleteConfirmationDialogData {
  title: string;
  description: string;
  yesButtonText: string;
  noButtonText: string;
}

@Component({
  selector: 'app-delete-confirmation-dialog',
  templateUrl: './delete-confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteConfirmationDialogComponent {
  DialogTemplateIconColorEnum = DialogTemplateIconColorEnum;
  DialogTemplateTitleColorEnum = DialogTemplateTitleColorEnum;
  DialogTemplateButtonComboStyleEnum = DialogTemplateButtonComboStyleEnum;

  constructor(public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationDialogData) {
  }

  onAction(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }

  static open(dialog: MatDialog, data: DeleteConfirmationDialogData): MatDialogRef<DeleteConfirmationDialogComponent, boolean> {
    return dialog.open(DeleteConfirmationDialogComponent, {
      data: data,
      width: '550px',
    });
  }
}
